export const EVENTS_SCHEMA_VERSION = "0.62.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.31.0";
